import script from "./PgmBudgetMain.vue?vue&type=script&setup=true&lang=ts"
export * from "./PgmBudgetMain.vue?vue&type=script&setup=true&lang=ts"

import "./PgmBudgetMain.vue?vue&type=style&index=0&id=4f8aa8ff&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-4f8aa8ff"]])

export default __exports__